import React, { useState, useEffect } from "react";
import { Form, Switch, Checkbox, Row, Col, Button, Spin, message, Radio, Modal } from "antd";
import { connect } from "react-redux";
import {
  setBreakTypesList,
  setLeaveCategoryList,
  setRoleList,
} from "redux/actions";
import {
  getLocations,
  getClientid,
  getAllDepartmentList,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import { CALL_API } from "common/API";
import {
  STATUS_CODE,
  VALIDATE_CHARACTER,
  VALIDATE_SYMBOL_CHARACTER,
} from "common/Constants";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import EditSelectTable from "molecules/EditSelectTable";
import TabsList from "molecules/TabsList";
import { getEditLeaveJson } from "JsonFormat/EditLeaveJson";
import FormModal from "./FormModal";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import styled from "styled-components";
import { LoadingOutlined } from '@ant-design/icons';
import moment from "moment";

const StyledButton = styled(Button)`
  background-color: #00685F;
  border-radius: 5px;
  color: #FFFFFF !important;
  width: 100px;
  ${'' /* font-weight: bold; */}
  &:hover {   background-color: #00685F;
  border-color: #00685F;
  color: #ffffff !important;
`;

const EditLeaves = ({
  isModalVisible,
  closeModal,
  ClientId,
  getLeaveList,
  LeaveDetails,
  saveLeaveCategoryList,
  departmentList,
  locationList,
  viewOnly,
  saveRoleList,
}) => {
  const [form] = Form.useForm();

  const fetchMasterData = async (fetch_master_data) => {
    const { code, leaveCategories, roleList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      saveLeaveCategoryList(leaveCategories);
      saveRoleList(roleList);
    }
  };

  const [data, setData] = useState({});
  useEffect(() => {
    const fixedYear = moment().add(1, "year").year();
    console.log(LeaveDetails?.expirydate, "LeaveDetails?.expiry_date")
    setData({
      leaveCategoryId: LeaveDetails.leaveCategoryId,
      leaveCategoryName: LeaveDetails.leaveCategoryName,
      numberOfLeaves: LeaveDetails.numberOfLeaves,
      eligible: LeaveDetails.eligible,
      holiday: LeaveDetails?.holiday,
      weekend: LeaveDetails?.weekend,
      isSaturday: LeaveDetails?.isSaturday,
      accumulated: LeaveDetails?.accumulated,
      expiry_date: LeaveDetails?.expirydate
        ? moment(
          `${LeaveDetails.expirydate} ${fixedYear}`,
          "MMMM YYYY"
        )
        : null,

      // expiry_date: LeaveDetails?.expirydate,


      accrualtype: LeaveDetails?.accrualtype,
      accrual: LeaveDetails?.accrual,
      rollout: LeaveDetails?.rollout,
    });
  }, [LeaveDetails]);

  const { EditLeaveForm } = getEditLeaveJson(data);
  const [submit, setsubmit] = useState(false);
  const [create, setCreate] = useState(false);
  const [selectDepartmentId, setSelectDepartmentId] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [openDepartmentModal, setOpenDepartmentModal] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [selectAllDepartmentsChecked, setSelectAllDepartmentsChecked] =
    useState(false);
  const [selectAllLocationChecked, setSelectAllLocationChecked] =
    useState(false);

  useEffect(() => {
    form.setFieldsValue({
      leave_category_name: LeaveDetails.leaveCategoryName,
      numberofLeaves: LeaveDetails.numberOfLeaves,
      description: LeaveDetails.description,
      holidays: LeaveDetails?.holiday,
      weekend: LeaveDetails?.weekend,
      isSaturday: LeaveDetails?.isSaturday,
    });
    setSelectedLocationId(LeaveDetails.locationId);
    setSelectDepartmentId(LeaveDetails.departmentId);
  }, [LeaveDetails]);

  useEffect(() => {
    setSelectAllDepartmentsChecked(
      selectDepartmentId?.length === departmentList?.length
    );
    setSelectAllLocationChecked(
      selectedLocationId?.length === locationList?.length
    );
  }, [selectDepartmentId, departmentList, selectedLocationId, locationList]);

  const handleFormChange = (e) => {
    if (e.target.name === "accrual") {
      setShowPopup(true);
    }
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    setsubmit(true);
  };

  const departmentcolumns = [
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id) => {
        const check = selectDepartmentId?.includes(department_id)
          ? true
          : false;
        return (
          <Switch
            disabled={viewOnly}
            checked={check}
            size="small"
            onChange={(checked) => getDepartmentId(department_id, checked)}
          />
        );
      },
    },
  ];

  const getDepartmentId = (department_id, checked) => {
    const newDepartmentId = checked
      ? [...selectDepartmentId, department_id]
      : selectDepartmentId.filter((item) => item !== department_id);
    setSelectDepartmentId(newDepartmentId);
    setsubmit(true);
  };

  const handleSelectAllDepartmentsChange = (e) => {
    const checked = e.target.checked;
    setSelectAllDepartmentsChecked(checked);
    const allDepartmentIds = departmentList.map((item) => item.department_id);
    setSelectDepartmentId(checked ? allDepartmentIds : []);
    setsubmit(true);
  };

  const locatincolumns = [
    {
      title: "Location Name",
      dataIndex: "country",
      key: "location_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => {
        const check = selectedLocationId?.includes(location_id) ? true : false;
        return (
          <Switch
            disabled={viewOnly}
            size="small"
            checked={check}
            onChange={(checked) => getLocationId(location_id, checked)}
          />
        );
      },
    },
  ];

  const getLocationId = (location_id, checked) => {
    const newLocationId = checked
      ? [...selectedLocationId, location_id]
      : selectedLocationId.filter((item) => item !== location_id);
    setSelectedLocationId(newLocationId);
    setsubmit(true);
  };

  const handleSelectAllLocationChange = (e) => {
    const checked = e.target.checked;
    setSelectAllLocationChecked(checked);
    const allDepaetmentIds = locationList.map((item) => item.location_id);
    setSelectedLocationId(checked ? allDepaetmentIds : []);
    setsubmit(true);
  };

  // useEffect(() => {
  //   if (submit) {
  //     onFinish();
  //   }
  // }, [selectDepartmentId, selectedLocationId, data]);

  const onFinish = async () => {
    setCreate(true);
    const {
      leaveCategoryId,
      leaveCategoryName,
      numberOfLeaves,
      eligible,
      holiday,
      weekend,
      isSaturday,
      accrual,
      accrualtype,
      rollout,
      expiry_date
    } = data;
    const containsSpecialCharacters = !VALIDATE_SYMBOL_CHARACTER.test(leaveCategoryName);
    if (containsSpecialCharacters) {
      message.error("Leave category name contains invalid characters. Please remove special symbols or numbers");
      setCreate(false);
      return false;
    }
    const { code } = await CALL_API(
      `owner-leave/${ClientId}/${leaveCategoryId}`,
      "patch",
      {
        leavecategoryname: leaveCategoryName,
        numberofleaves: numberOfLeaves,
        department: selectDepartmentId,
        location: selectedLocationId,
        eligible: eligible,
        holiday: holiday,
        weekend: weekend,
        isSaturday: isSaturday,
        accumulated: data?.accumulated,
        // expiry_date: moment(expiry_date).format("MMMM YYYY") ?? null,
        expirydate: expiry_date
          ? moment(expiry_date)
            .endOf("month")
            .format("MMMM")
            .charAt(0)
            .toUpperCase() +
          moment(expiry_date)
            .endOf("month")
            .format("MMMM")
            .slice(1)
            .toLowerCase()
          : moment()
            .add(1, "year")
            .endOf("year")
            .format("MMMM")
            .charAt(0)
            .toUpperCase() +
          moment()
            .add(1, "year")
            .endOf("year")
            .format("MMMM")
            .slice(1)
            .toLowerCase(),
        accrual: accrual,
        rollout: rollout,
        accrualtype: accrual === "No" ? "Yearly" : accrualtype,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      const oldLocations = LeaveDetails.locationId || [];
      const newLocations = selectedLocationId || [];
      const newlyAddedLocations = newLocations?.filter(loc => !oldLocations.includes(loc));
      if (newlyAddedLocations.length === 0) {
        console.warn("No new locations added. Only updating category details.");
      } else {
        const secondPayload = {
          clientId: ClientId,
          leavecategoryId: leaveCategoryId,
          NewlocationId: selectedLocationId,
          numberofleaves: numberOfLeaves,
          OldlocationId: oldLocations,
          gender: eligible
        };

        const secondResponse = await CALL_API(
          `owner-leave/${ClientId}?updateleaveallocation=true`,
          "post",
          secondPayload
        );
        if (secondResponse.code === STATUS_CODE.SUCCESS) {
          message.success("Leave updated and allocation recalculated successfully");
        } else {
          // message.warning("Leave updated, but allocation update failed");
        }
      }
      // ---------------------------
      // Second API Call (POST)
      // ---------------------------

      closeModal();



      setCreate(false);
      fetchMasterData();
      getLeaveList();
    } else {
      setCreate(false);
    }
  };
  const handleSave = async () => {
    await onFinish(); // Ensure API call finishes before navigating
    closeModal();
  };

  const items = [
    {
      id: 1,
      label: "Basic",
      component: (
        <>
          {viewOnly ? (
            <>
              <div className="styled-card">
                <Row className="mb-1">
                  <Col>
                    <b>Leave Category Name</b> : {data.leaveCategoryName}
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col>
                    <b>Number of Leaves</b> : {data.numberofleaves}
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col>
                    <b>eligible</b> : {data.eligible}
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <div className="styled-card">
              <GridBuilder
                formStructureJson={EditLeaveForm}
                handleChange={handleFormChange}
                initialValues={data}
              />
            </div>
          )}
        </>
      ),
    },
    // {
    //   id: 2,
    //   label: "Department",
    //   component: (
    //     <>
    //       {!viewOnly && (
    //         <div className="mb-3 d-flex justify-content-between">
    //           {departmentList?.length > 0 && (
    //             <Checkbox
    //               className=""
    //               checked={selectAllDepartmentsChecked}
    //               onChange={handleSelectAllDepartmentsChange}
    //             >
    //               Select All
    //             </Checkbox>
    //           )}
    //         </div>
    //       )}
    //       <EditSelectTable
    //         columns={departmentcolumns}
    //         tabledata={departmentList}
    //         setOpenModal={() => setOpenDepartmentModal(true)}
    //         Name="Add Department"
    //       />
    //       <FormModal
    //         isModalVisible={openDepartmentModal}
    //         closeModal={() => setOpenDepartmentModal(false)}
    //         Name="Department"
    //       />
    //     </>
    //   ),
    // },
    {
      id: 3,
      label: "Country",
      component: (
        <>
          {!viewOnly && (
            <div className="mb-3 d-flex justify-content-between">
              {locationList?.length > 0 && (
                <Checkbox
                  className=""
                  checked={selectAllLocationChecked}
                  onChange={handleSelectAllLocationChange}
                >
                  Select All
                </Checkbox>
              )}
            </div>
          )}

          <EditSelectTable
            columns={locatincolumns}
            tabledata={locationList}
            setOpenModal={() => setOpenLocationModal(true)}
            Name="Add Location"
          />
          <FormModal
            isModalVisible={openLocationModal}
            closeModal={() => setOpenLocationModal(false)}
            Name="Location"
          />
        </>
      ),
    },
  ];

  return (
    <>
      {isModalVisible && (
        <>
          <LeaveStyle>
            <div className="d-flex justify-content-between">
              <div className="leave_header_content">
                <label
                  className="bg-transparent border-0 mb-3 text-left styled-cursor"
                  onClick={() => {
                    closeModal(false);
                  }}
                >
                  Leave
                  <ArrowForwardIosIcon className="px-1" />
                </label>{" "}
                <b className=" pb-0 pt-1">{data.leaveCategoryName}</b>
              </div>
              <div className="location_header_action">
                <StyledButton onClick={handleSave}>{create && <Spin indicator={<LoadingOutlined spin />} />}Save</StyledButton>
              </div>
            </div>
          </LeaveStyle>

          <TabsList items={items} form={form} />
          <Modal
            // title="Leave Settings"
            header={null}
            open={showPopup}
            onCancel={() => setShowPopup(false)}
            footer={null}
            centered
            maskClosable={false}
          >
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  fontWeight: 500,
                  fontSize: 16,
                  display: "block",
                  marginBottom: 8,
                }}
              >
                <span style={{ color: "red", marginRight: 4 }}>*</span>
                Do you want to roll over this leave to next year?
              </label>

              <Radio.Group
                value={data?.rollout}
                onChange={(e) => {
                  setData((prev) => ({
                    ...prev,
                    rollout: e.target.value,
                    expiry_date: e.target.value === "No" ? null : prev.expiry_date,
                  }));
                  setShowPopup(false);
                }}
              >
                <Radio value={"Yes"}>Yes</Radio>
                <Radio value={"No"}>No</Radio>
              </Radio.Group>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  ClientId: getClientid(state),
  locationList: getLocations(state),
  departmentList: getAllDepartmentList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setBreakTypes: setBreakTypesList,
      saveLeaveCategoryList: setLeaveCategoryList,
      saveRoleList: setRoleList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps, null)(EditLeaves);

const LeaveStyle = styled.div`
  .leave_header_content{
    width: max-content;
  }
  .leave_header_action{
    width: 20px;
    height: 20px;
    width: max-content;
  }
`;